<template>
	<div class="container_t_padding clearfix">
		<div class="price_banner"></div>
		<div class="serve_middle price_box clearfix">
			<img src="../../assets/serve_img1.png" />
			<img src="../../assets/serve_img2.png" />
			<img src="../../assets/serve_img3.png" />
		</div>
	</div>
</template>

<script>
	export default{
		metaInfo: {
			title: '经纪人app会员价格_服务体系_企业会员特权_芒果科技蜗牛哥', // set a title
			meta: [{             // set meta
			  name: 'keyWords',
			  content: '蜗牛哥经纪人价格,企业特权,会员特权,企业会员,VIP,普通会员'
			},
			{
			  name: 'description',
			  content: '蜗牛哥经纪人app会员服务体系通过企业和个人进行产品内容及价格区别'
			}]
		}
	}
</script>

<style lang="less">
	.price_banner {
		min-width: 1200px; height: 328px; background: url(../../assets/serve_banner.png) top center no-repeat;
	}
	.price_box {
		width: 1000px !important;
	}
</style>
